// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"yb_a bik_vp bik_vh bik_xe bik_rg bik_tr bik_qx"};